<template>
  <div class="itemFrameContainer">
    <NsBadge :overlap="true" :color="'#bb29bb'" class="iconContainer">
      <span slot="badge-content" class="itemCountBadge" :id="'returnQuantityBadge_' + itemSku">{{itemCount}}</span>
      <img v-if="itemImageUrl !== ''" slot="badge-anchor" class="itemPicture" :src="itemImageUrl" />
      <NsIcon v-else slot="badge-anchor" class="itemPicture" icon-name="icon-product-placeholder-26" />
    </NsBadge>
    <div class="itemName">{{itemName}}</div>
  </div>
</template>

<script>
import { NsIcon } from '@nuskin/ns-icon'
import {
  NsBadge,
} from '@nuskin/design-components'
export default {
  components: {
    NsIcon,
    NsBadge,
  },
  props: {
    itemCount: {
      type: Number,
      default: 0,
    },
    itemImageUrl: {
      type: String,
      default: '',
    },
    itemName: {
      type: String,
      default: 'Item Name Not Found',
    },
    itemSku: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
  .itemFrameContainer {
    display: flex;
    justify-self: flex-start;
    align-items: center;
    .itemPicture {
      height: 40px;
      width: 40px;
      border: 1px solid #CED0D0;
      padding: 5px;
      border-radius: 6px;
    }
    .itemName {
      margin-left: 15px;
      font-size: 14px;
      font-weight: 400;
      color: #272525;
    }
  }
</style>
